import { defineBlocksWithJsonArray } from 'blockly/core';

const SOUND_STYLE = 'beginner_sound_blocks';

const microphoneBlockDefinitions = [
  {
    type: 'beginner_mic_is_loud',
    message0: 'is loud sound?',
    output: 'Boolean',
    style: SOUND_STYLE,
    tooltip: 'True when the microphone hears a loud sound.',
    helpUrl: '',
  },
  {
    type: 'beginner_mic_sound_level',
    message0: 'sound level',
    output: 'Number',
    style: SOUND_STYLE,
    tooltip: 'How loud the sound is (0–100%).',
    helpUrl: '',
  },
  {
    type: 'beginner_mic_wait_loud',
    message0: 'wait until loud sound',
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Waits until the microphone hears a loud sound.',
    helpUrl: '',
  },
  {
    type: 'beginner_mic_when_loud',
    message0: 'when loud sound detected %1',
    args0: [{ type: 'input_statement', name: 'DO' }],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Runs the blocks inside when a loud sound is detected.',
    helpUrl: '',
  },
];

export function registerBeginnerMicrophoneBlocks(): void {
  defineBlocksWithJsonArray(microphoneBlockDefinitions);
}
